<template>
    <div class="popup-layout popup-layout--3">
        <div class="popup popup--8">
            <div class="confirmation">
                <p v-if="title" class="h3 confirmation__title">
                    {{ title }}
                </p>
                <div>
                    <div class="confirmation__buttons">
                        <Button
                            title="отмена"
                            extraClass="button--white"
                            :onClick="onClose"
                        />
                        <Button
                            title="Подтвердить"
                            extraClass="button--confirm"
                            :onClick="onConfirm"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "@/views/components/Button/Button";

export default {
    name: "Confirmation",

    components: {
        Button,
    },

    props: {
        title: String,
        onClose: Function,
        onConfirm: Function,
    },

    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
@import "Confirmation.scss";
</style>
